import { InAppMessage } from "../../core/internal/model/model"
import { HackleInAppMessage, HackleInAppMessageView } from "../../public/model"
import { InAppMessageView } from "./ui/view/InAppMessageView"

export class InAppMessageConverter {
  static toPublic(inAppMessage: InAppMessage): HackleInAppMessage {
    return {
      key: inAppMessage.key
    }
  }
}

export class InAppMessageViewConverter {
  static toPublic(view: InAppMessageView): HackleInAppMessageView {
    return {
      close: view.close.bind(view),
      inAppMessage: InAppMessageConverter.toPublic(view.context.inAppMessage)
    }
  }
}
